export const MONTHLY_FIELDS = {
  id: 'id',
  date: 'التاريخ',
  storeName: 'المتجر',
  branchName: 'الفرع',
  appKey: 'معرف المتجر',
  appBranchId: 'معرف الفرع',
  app: 'التطبيق',
  completed: "المكتملة",
  completedAmount: "قيمة الطلبات",
  rejected: "المرفوضة",
  rejectedAmount: "قيمة المرفوضة",
  canceled: "الملغاة",
  canceledAmount: "قيمة الملغاة",
  endurance: 'التحمل',
  refund: 'الاسترداد',
  ccAmount: "العمولات البنكية",
  deliveryOffer: "الحملات",
  offers: 'العروض',
  serviceCharge: "النسبة",
  enduranceAmount: "قيمة التحمل",
  refundAmount: "قيمة الاسترداد",
  posDevice: "رسوم جهاز POS",
  vat: "الضريبة",
  grandTotal: "الصافي"
}
export const MONTHLY_FIELDS2 = {
  id: 'id',
  date: 'date',
  storeName: 'storeName',
  branchName: 'branchName',
  storeId: 'storeId',

  appKey: 'appKey',
  branchRef: 'branchRef',

  appBranchId: 'appBranchId',
  app: 'app',
  completed: 'completed',
  completedAmount: 'completedAmount',
  rejected: 'rejected',
  rejectedAmount: 'rejectedAmount',
  canceled: 'canceled',
  canceledAmount: 'canceledAmount',
  endurance: 'endurance',
  refund: 'refund',
  ccAmount: 'ccAmount',
  deliveryOffer: 'deliveryOffer',
  offers: 'offers',
  serviceCharge: 'serviceCharge',
  enduranceAmount: 'enduranceAmount',
  refundAmount: 'refundAmount',
  posDevice: 'posDevice',
  vat: 'vat',
  grandTotal: 'grandTotal'
}

